import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconAdd = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({ viewBox: "-3 -3 24 24" }, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M10 7.99902V-0.000976562H8V7.99902H0V9.99902H8V17.999H10V9.99902H18V7.99902H10Z" }))));
};
